<div class="simple-dialog-container">
  <!-- Close Icon -->
  <i [mat-dialog-close] class="fas fa-times close-icon"></i>

  <!-- Title -->
  <h2 class="dialog-title">Cerrar sesión</h2>

  <!-- Message -->
  <p class="dialog-message">
    ¿Estás seguro que querés cerrar sesión? Los datos no guardados se perderán.
  </p>

  <!-- Actions -->
  <div class="dialog-actions">
    <!-- Cancel -->
    <button [mat-dialog-close] class="button button-grey-outline mr-2">
      <i class="fas fa-times"></i>
      Cancelar
    </button>

    <!-- Next -->
    <button
      (click)="onLogout()"
      [class.loading]="signingOut$ | async"
      [disabled]="signingOut$ | async"
      class="button button-red"
    >
      <i class="fas fa-sign-out-alt"></i>
      Cerrar sesión
    </button>
  </div>
</div>
